<template>
  <div class="confirm">
    <div class="confirm-box">
      <div class="content">
        <div class="title">
          {{option.title}}
        </div>
        <div class="words">
          {{option.words}}
        </div>
      </div>
      <div class="bottom-bar">
        <div class="ok" v-if="option.okWord" @click="onOkClick">
          {{option.okWord}}
        </div>
        <div class="cancle" v-if="option.cancleWord" @click="onCancleClick">
          {{option.cancleWord}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['option'],
    methods: {
      onOkClick() {
        let message = {
          'from': 'confirm',
          'oper': 'ok',
          'to': this.option.to,
          'params': this.option.params
        }
        this.$emit('childOper', message)
      },
      onCancleClick() {
        let message = {
          'from': 'confirm',
          'oper': 'cancel',
          'to': this.option.to,
          'params': this.option.params
        }
        this.$emit('childOper', message)
      },
    }
  }

</script>

<style scoped>
  .confirm{
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(169,169,169,0.8);
    z-index: 8;
  }
  .confirm-box {
    width: 200px;
    height: 200px;
    position: fixed;
    left: calc(50% - 100px);
    top: 200px;
    display: flex;
    flex-direction: column;
    text-align: center;
    z-index: 10;
    background-color: rgb(244, 246, 248);
    border-radius: 10px;
    box-sizing: border-box;
  }

  .content {
    height: 150px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
  }

  .content .title {
    height: 50px;
    line-height: 50px;
    font-size: 17px;
    color: red;
    box-sizing: border-box;
  }

  .content .words {
    height: 100px;
    font-size: 14px;
    color: rgb(192, 156, 156);
    box-sizing: border-box;
    padding-top: 15px;
  }

  .bottom-bar {
    height: 50px;
    display: flex;
    line-height: 50px;
    font-size: 16px;
    border-top: 1px solid #ccc;
    box-sizing: border-box;
    cursor: pointer;
  }

  .bottom-bar .ok {
    width: 0;
    flex-grow: 1;
    color: green;
    border-right: 1px solid #ccc;
    box-sizing: border-box;
  }

  .bottom-bar .cancle {
    width: 0;
    flex-grow: 1;
    color: rgb(161, 157, 157);
    box-sizing: border-box;
  }

</style>



// WEBPACK FOOTER //
// src/components/confirm.vue